import axios from "axios";
import { useAuthPersistedStore } from "shared/store";

const isItLocal = window.location.href.includes("localhost");

/**
 * @deprecated since new src/shared/api client
 */
export const client = axios.create({
  baseURL: isItLocal ? "http://localhost:8000" : "/",
  responseType: "json",
  withCredentials: true,
  headers: {
    "X-User-Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

export const blobClient = axios.create({
  baseURL: isItLocal ? "http://localhost:8000" : "/",
  responseType: "blob",
  withCredentials: true,
  headers: {
    "X-User-Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;

    if (status === 400 || status === 401) {
      useAuthPersistedStore.getState().setIsLoggedIn(false);
    }
    return Promise.reject(error);
  }
);

blobClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;

    if (status === 400 || status === 401) {
      useAuthPersistedStore.getState().setIsLoggedIn(false);
    }
    return Promise.reject(error);
  }
);
